// Browser stub for @qdrant/js-client-rest
// Qdrant is a vector database client that uses undici (Node.js-only HTTP client)
// This stub prevents runtime errors when code tries to use Qdrant in the browser
//
// Note: Qdrant functionality should not be used in the browser bundle.
// If you see this stub being used, consider moving Qdrant operations to the backend.

module.exports = {
    QdrantClient: class QdrantClient {
        constructor(config) {
            console.warn(
                "@qdrant/js-client-rest is not available in the browser - Qdrant operations should be performed server-side",
            );
        }
        // Stub methods to prevent crashes if code tries to call them
        async upsert() {
            throw new Error(
                "Qdrant operations are not available in the browser - use server-side API instead",
            );
        }
        async search() {
            throw new Error(
                "Qdrant operations are not available in the browser - use server-side API instead",
            );
        }
        async retrieve() {
            throw new Error(
                "Qdrant operations are not available in the browser - use server-side API instead",
            );
        }
        async delete() {
            throw new Error(
                "Qdrant operations are not available in the browser - use server-side API instead",
            );
        }
    },
};
